var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-badge"},[_c('div',{staticClass:"frame"},[_c('span',{staticClass:"initials"},[_vm._v(_vm._s(_vm.initials))])])])}
var staticRenderFns = []

export { render, staticRenderFns }